import radio433mhz from './system/433mhz.svg';
import radio868mhz from './system/868mhz.svg';
import account from './system/account.svg';
import advancedFlow from './system/advanced-flow.svg';
import alarms from './system/alarms.svg';
import alexa from './system/alexa.svg';
import apiKeys from './system/api-keys.svg';
import appearanceSettings from './system/appearance-settings.svg';
import apps from './system/apps.svg';
import audio from './system/audio.svg';
import backups from './system/backups.svg';
import batteries from './system/batteries.svg';
import bluetooth from './system/bluetooth.svg';
import camera from './system/camera.svg';
import capabilities from './system/capabilities.svg';
import climate from './system/climate.svg';
import coprocessor from './system/coprocessor.svg';
import dashboards from './system/dashboards.svg';
import dateTime from './system/date-time.svg';
import devTools from './system/dev-tools.svg';
import devices from './system/devices.svg';
import discover from './system/discover.svg';
import energy from './system/energy.svg';
import ethernetAdapter from './system/ethernet-adapter.svg';
import experiments from './system/experiments.svg';
import family from './system/family.svg';
import feedback from './system/feedback.svg';
import flow from './system/flow.svg';
import general from './system/general.svg';
import google from './system/google.svg';
import homeAway from './system/home-away.svg';
import home from './system/home.svg';
import homeyBridge from './system/homey-bridge.svg';
import homeyCloud from './system/homey-cloud.svg';
import homeyPro2019 from './system/homey-pro-2019.svg';
import homeyProMini from './system/homey-pro-mini.svg';
import homeyPro from './system/homey-pro.svg';
import homeyShs from './system/homey-shs.svg';
import homeyscript from './system/homeyscript.svg';
import ifttt from './system/ifttt.svg';
import infrared from './system/infrared.svg';
import insights from './system/insights.svg';
import language from './system/language.svg';
import ledRing from './system/led-ring.svg';
import lights from './system/lights.svg';
import location from './system/location.svg';
import logic from './system/logic.svg';
import matter from './system/matter.svg';
import moods from './system/moods.svg';
import more from './system/more.svg';
import newsletter from './system/newsletter.svg';
import nfc from './system/nfc.svg';
import note from './system/note.svg';
import ota from './system/ota.svg';
import permissions from './system/permissions.svg';
import premium from './system/premium.svg';
import presence from './system/presence.svg';
import pushNotifications from './system/push-notifications.svg';
import referFriend from './system/refer-friend.svg';
import reminders from './system/reminders.svg';
import review from './system/review.svg';
import safety from './system/safety.svg';
import satellite from './system/satellite.svg';
import schedules from './system/schedules.svg';
import security from './system/security.svg';
import settings from './system/settings.svg';
import siriShortcuts from './system/siri-shortcuts.svg';
import speech from './system/speech.svg';
import support from './system/support.svg';
import thread from './system/thread.svg';
import timelineNotifications from './system/timeline-notifications.svg';
import updates from './system/updates.svg';
import weather from './system/weather.svg';
import webApp from './system/web-app.svg';
import web from './system/web.svg';
import wifi from './system/wifi.svg';
import zWave from './system/z-wave.svg';
import zigbee from './system/zigbee.svg';
import zone from './system/zone.svg';

export const system = {
  radio433mhz,
  radio868mhz,
  account,
  advancedFlow,
  alarms,
  alexa,
  apiKeys,
  appearanceSettings,
  apps,
  audio,
  backups,
  batteries,
  bluetooth,
  camera,
  capabilities,
  climate,
  coprocessor,
  dashboards,
  dateTime,
  devTools,
  devices,
  discover,
  energy,
  ethernetAdapter,
  experiments,
  family,
  feedback,
  flow,
  general,
  google,
  homeAway,
  home,
  homeyBridge,
  homeyCloud,
  homeyPro2019,
  homeyProMini,
  homeyPro,
  homeyShs,
  homeyscript,
  ifttt,
  infrared,
  insights,
  language,
  ledRing,
  lights,
  location,
  logic,
  matter,
  moods,
  more,
  nfc,
  newsletter,
  note,
  ota,
  permissions,
  premium,
  presence,
  pushNotifications,
  referFriend,
  reminders,
  review,
  safety,
  satellite,
  schedules,
  security,
  settings,
  siriShortcuts,
  speech,
  support,
  thread,
  timelineNotifications,
  updates,
  weather,
  webApp,
  web,
  wifi,
  zWave,
  zigbee,
  zone,
} as const;
